import { Box, Container, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { addLocalePrefix } from 'utils/routes.utils';

import { Routes } from 'constants/routes.constants';
import { useLocale } from 'hooks/useLocale';

import AppCompactNavigation from 'components/@navigation/AppCompactNavigation';

import Footer from './Footer';
import RequestedScreen from './RequestedScreen';

const UnsupportedDeviceContainer = ({}) => {
  const { locale } = useLocale();
  const [isSuccess, setSuccess] = useState(false);
  const redirectUrl = addLocalePrefix(locale, Routes.UnsupportedDevice);

  const handleSuccess = () => setSuccess(true);

  if (isSuccess) return <RequestedScreen />;

  return (
    <AppCompactNavigation>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: { xs: 'flex', md: 'grid' },
            gridTemplateColumns: '6fr 1fr 5fr',
            flexDirection: { xs: 'column', md: 'row' },
            flex: '1',
          }}
        >
          <Box
            sx={{
              flex: '1',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography variant="h6" component="h1">
              <FormattedMessage id="unsupported_device.title" />
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
                mt: 1,
              }}
            >
              <FormattedMessage
                id="unsupported_device.description"
                values={{
                  br: <br />,
                }}
              />
            </Typography>
          </Box>
          <Box
            sx={{
              display: { xs: 'none', md: 'block' },
            }}
          />
          <Footer redirectUrl={redirectUrl} onSuccess={handleSuccess} />
        </Box>
      </Container>
    </AppCompactNavigation>
  );
};

export default UnsupportedDeviceContainer;
